import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
const AtlassianSupportsUkraineSplit = lazyForPaint(() => import( /* webpackChunkName: "chunk-support-ukraine-details" */'./AtlassianSupportsUkraineRoute').then(c => c.default));
export default function AtlassianSupportsUkraineRouteHandler() {
  return /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(AtlassianSupportsUkraineSplit, null));
}